import React from 'react';
import { func } from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import AddCircle from '@material-ui/icons/AddCircle';
import { makeStyles } from '@material-ui/core/styles';
import { track } from '../../../../modules/Analytics';

const useStyles = makeStyles(theme => ({
  light: {
    color: theme.palette.secondary.main,
  },
  medium: {
    color: theme.palette.secondary.main,
    fontFamily: theme.typography.h1.fontFamily,
  },
  add: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));

const AddLocation = ({ addLocationField }) => {
  const classes = useStyles();
  return (
    <Box display="flex" alignItems="center" p={1} pl={2}>
      <Box
        testid="add-location"
        onClick={() => {
          track('Location - Add Destination', {});
          addLocationField();
        }}
        display="flex"
        alignItems="center"
        className={classes.add}
      >
        <AddCircle className={classes.light} />
        <Box ml={2.5}>
          <Typography className={classes.medium} variant="body2">
            Add destination
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

AddLocation.propTypes = {
  addLocationField: func.isRequired,
};

export default AddLocation;
